import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Organization } from '../classes/organization';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  constructor(private httpClient: HttpClient) { }

  /* 
    Areas 
  */
  public deleteArea(areaId: number): Observable<any> {
    return this.httpClient.delete(`/api/areas/${areaId}`);
  }

  public getArea(areaId: number): Observable<any> {
    return this.httpClient.get(`/api/areas/${areaId}`);
  }

  public getAreas(): Observable<any> {
    return this.httpClient.get('/api/areas');
  }

  public saveArea(areaId: number, data: object): Observable<any> {
    return this.httpClient.post(`/api/areas/${areaId ? areaId : ''}`, data);
  }

  /* 
    Badges 
  */
  public deleteBadge(badgeId: number): Observable<any> {
    return this.httpClient.delete(`/api/badges/${badgeId}`);
  }

  public getBadge(badgeId: number): Observable<any> {
    return this.httpClient.get(`/api/badges/${badgeId}`);
  }

  public getBadges(): Observable<any> {
    return this.httpClient.get('/api/badges');
  }

  public saveBadge(badgeId: number, data: object): Observable<any> {
    return this.httpClient.post(`/api/badges/${badgeId ? badgeId : ''}`, data);
  }

  public badgeCreateToOtherOrganizations(badgeId: number): Observable<any> {
    return this.httpClient.get(`/api/badges/${badgeId}/create-to-other-organizations`, {});
  }

  public badgeUpdateToOtherOrganizations(badgeId: number): Observable<any> {
    return this.httpClient.get(`/api/badges/${badgeId}/update-to-other-organizations`, {});
  }
  /* 
    Assignments 
  */
  public deleteAssignment(assignmentId: number): Observable<any> {
    return this.httpClient.delete(`/api/assignments/${assignmentId}`);
  }
  public getAssignment(assignmentId: number): Observable<any> {
    return this.httpClient.get(`/api/assignments/${assignmentId}`);
  }

  public getAssignments(): Observable<any> {
    return this.httpClient.get('/api/assignments');
  }

  public searchAssignments(query: {}): Observable<any> {
    return this.httpClient.get('/api/assignments', { params: new HttpParams({ fromObject: query }) });
  }

  public saveAssignment(assignmentId: number, data: object): Observable<any> {
    return this.httpClient.post(`/api/assignments/${assignmentId ? assignmentId : ''}`, data);
  }

  public assignmentPricings(assignmentId: number): Observable<any> {
    return this.httpClient.get(`/api/assignments/${assignmentId}/pricings`);
  }

  public assignmentPricing(assignmentId: number, pricingId: number): Observable<any> {
    return this.httpClient.get(`/api/assignments/${assignmentId}/pricings/${pricingId}`);
  }

  public assignmentPricingDelete(assignmentId: number, pricingId: number): Observable<any> {
    return this.httpClient.delete(`/api/assignments/${assignmentId}/pricings/${pricingId}`);
  }

  public assignmentPricingSave(assignmentId: number, pricingId: number, data: object): Observable<any> {
    return this.httpClient.post(`/api/assignments/${assignmentId}/pricings/${pricingId ? pricingId : ''}`, data);
  }

  public assignmentSalaries(assignmentId: number): Observable<any> {
    return this.httpClient.get(`/api/assignments/${assignmentId}/salaries`);
  }

  public assignmentSalary(assignmentId: number, salaryId: number): Observable<any> {
    return this.httpClient.get(`/api/assignments/${assignmentId}/salaries/${salaryId}`);
  }

  public assignmentSalaryDelete(assignmentId: number, salaryId: number): Observable<any> {
    return this.httpClient.delete(`/api/assignments/${assignmentId}/salaries/${salaryId}`);
  }

  public assignmentSalarySave(assignmentId: number, salaryId: number, data: object): Observable<any> {
    return this.httpClient.post(`/api/assignments/${assignmentId}/salaries/${salaryId ? salaryId : ''}`, data);
  }

  public assignmentProductList(assignmentId: number): Observable<any> {
    return this.httpClient.get(`/api/assignments/${assignmentId}/products`)
  }

  public assignmentCreateToOtherOrganizations(assignmentId: number): Observable<any> {
    return this.httpClient.get(`/api/assignments/${assignmentId}/create-to-other-organizations`, {});
  }

  public assignmentUpdateToOtherOrganizations(assignmentId: number): Observable<any> {
    return this.httpClient.get(`/api/assignments/${assignmentId}/update-to-other-organizations`, {});
  }

  public assignmentGenerate(data: {}): Observable<any> {
    return this.httpClient.post(`/api/assignments/generate`, data);
  }

  public assignmentGenerateAgents(data: {}): Observable<any> {
    return this.httpClient.post(`/api/assignments/generate-agents`, data);
  }

  /* 
    Cities
  */
  public deleteCity(cityId: number): Observable<any> {
    return this.httpClient.delete(`/api/cities/${cityId}`);
  }

  public getCity(cityId: number): Observable<any> {
    return this.httpClient.get(`/api/cities/${cityId}`);
  }

  public getCities(): Observable<any> {
    return this.httpClient.get('/api/cities');
  }

  public saveCity(cityId: number, data: object): Observable<any> {
    return this.httpClient.post(`/api/cities/${cityId ? cityId : ''}`, data);
  }

  public createCityAreas(cityId: number, save: boolean = false): Observable<any> {
    return this.httpClient.post(`/api/cities/${cityId}/areas`, { save: save });
  }

  /* 
    Customer groups 
  */
  public deleteCustomerGroup(gruopId: number): Observable<any> {
    return this.httpClient.delete(`/api/customer-groups/${gruopId}`);
  }
  public getCustomerGroup(gruopId: number): Observable<any> {
    return this.httpClient.get(`/api/customer-groups/${gruopId}`);
  }

  public getCustomerGroups(): Observable<any> {
    return this.httpClient.get('/api/customer-groups');
  }

  public saveCustomerGroup(gruopId: number, data: object): Observable<any> {
    return this.httpClient.post(`/api/customer-groups/${gruopId ? gruopId : ''}`, data);
  }

  /* 
    Partner groups 
  */
  public deleteEmployeeGroup(gruopId: number): Observable<any> {
    return this.httpClient.delete(`/api/employee-groups/${gruopId}`);
  }
  public getEmployeeGroup(gruopId: number): Observable<any> {
    return this.httpClient.get(`/api/employee-groups/${gruopId}`);
  }

  public getEmployeeGroups(): Observable<any> {
    return this.httpClient.get('/api/employee-groups');
  }

  public saveEmployeeGroup(gruopId: number, data: object): Observable<any> {
    return this.httpClient.post(`/api/employee-groups/${gruopId ? gruopId : ''}`, data);
  }

  /* 
    Holidays
  */
  public deleteHoliday(holidayId: number): Observable<any> {
    return this.httpClient.delete(`/api/holidays/${holidayId}`);
  }
  public getHoliday(holidayId: number): Observable<any> {
    return this.httpClient.get(`/api/holidays/${holidayId}`);
  }

  public getHolidayAlert(): Observable<any> {
    return this.httpClient.get(`/api/holidays/alert`);
  }

  public getHolidays(): Observable<any> {
    return this.httpClient.get('/api/holidays');
  }

  public saveHoliday(holidayId: number, data: object): Observable<any> {
    return this.httpClient.post(`/api/holidays/${holidayId ? holidayId : ''}`, data);
  }

  /*
    Message templates
  */
  public deleteMessageTemplate(templateId: number): Observable<any> {
    return this.httpClient.delete(`/api/message-templates/${templateId}`);
  }
  public getMessageTemplate(templateId: number): Observable<any> {
    return this.httpClient.get(`/api/message-templates/${templateId}`);
  }

  public getMessageTemplates(): Observable<any> {
    return this.httpClient.get('/api/message-templates');
  }

  public saveMessageTemplate(templateId: number, data: object): Observable<any> {
    return this.httpClient.post(`/api/message-templates/${templateId ? templateId : ''}`, data);
  }

  public getMessageTemplateAlerts(): Observable<any> {
    return this.httpClient.get(`/api/message-templates/alert`);
  }

  public messageTemplatetCreateToOtherOrganizations(templateId: number): Observable<any> {
    return this.httpClient.get(`/api/message-templates/${templateId}/create-to-other-organizations`, {});
  }

  public messageTemplatetUpdateToOtherOrganizations(templateId: number): Observable<any> {
    return this.httpClient.get(`/api/message-templates/${templateId}/update-to-other-organizations`, {});
  }

  /* 
    Pricings
  */

  public copyPricing(priceId: number, data: {}): Observable<any> {
    return this.httpClient.post(`/api/pricings/${priceId}/copy`, data);
  }

  public deletePricing(priceId: number): Observable<any> {
    return this.httpClient.delete(`/api/pricings/${priceId}`);
  }
  public getPricing(priceId: number): Observable<any> {
    return this.httpClient.get(`/api/pricings/${priceId}`);
  }

  public getPricings(): Observable<any> {
    return this.httpClient.get('/api/pricings');
  }

  public savePricing(priceId: number, data: object): Observable<any> {
    return this.httpClient.post(`/api/pricings/${priceId ? priceId : ''}`, data);
  }

  /* 
    Skills
  */
  public deleteSkill(skillId: number): Observable<any> {
    return this.httpClient.delete(`/api/skills/${skillId}`);
  }
  public getSkill(skillId: number): Observable<any> {
    return this.httpClient.get(`/api/skills/${skillId}`);
  }

  public getSkills(): Observable<any> {
    return this.httpClient.get('/api/skills');
  }

  public saveSkill(skillId: number, data: object): Observable<any> {
    return this.httpClient.post(`/api/skills/${skillId ? skillId : ''}`, data);
  }

  /* 
    Skill groups
  */
  public deleteSkillGroup(groupId: number): Observable<any> {
    return this.httpClient.delete(`/api/skill-groups/${groupId}`);
  }
  public getSkillGroup(groupId: number): Observable<any> {
    return this.httpClient.get(`/api/skill-groups/${groupId}`);
  }

  public getSkillGroups(): Observable<any> {
    return this.httpClient.get('/api/skill-groups');
  }

  public saveSkillGroup(groupId: number, data: object): Observable<any> {
    return this.httpClient.post(`/api/skill-groups/${groupId ? groupId : ''}`, data);
  }

  /* 
    Salary Rules
  */
  public deleteSalaryRule(salaryRuleId: number): Observable<any> {
    return this.httpClient.delete(`/api/salary-rules/${salaryRuleId}`);
  }
  public getSalaryRule(salaryRuleId: number): Observable<any> {
    return this.httpClient.get(`/api/salary-rules/${salaryRuleId}`);
  }

  public getSalaryRules(): Observable<any> {
    return this.httpClient.get('/api/salary-rules');
  }

  public saveSalaryRule(salaryRuleId: number, data: object): Observable<any> {
    return this.httpClient.post(`/api/salary-rules/${salaryRuleId ? salaryRuleId : ''}`, data);
  }

  public deleteSalaryRuleRuleset(salaryRuleId: number, rulesetId: number): Observable<any> {
    return this.httpClient.delete(`/api/salary-rules/${salaryRuleId}/rulesets/${rulesetId}`);
  }

  public getSalaryRuleRuleset(salaryRuleId: number, rulesetId: number): Observable<any> {
    return this.httpClient.get(`/api/salary-rules/${salaryRuleId}/rulesets/${rulesetId}`);
  }

  public getSalaryRuleRulesets(salaryRuleId: number): Observable<any> {
    return this.httpClient.get(`/api/salary-rules/${salaryRuleId}/rulesets`);
  }

  public saveSalaryRuleRuleset(salaryRuleId: number, rulesetId: number, data: {}): Observable<any> {
    return this.httpClient.post(`/api/salary-rules/${salaryRuleId}/rulesets/${rulesetId ? rulesetId : ''}`, data);
  }

  public deleteSalaryRuleRulesetRule(salaryRuleId: number, rulesetId: number, ruleId: number): Observable<any> {
    return this.httpClient.delete(`/api/salary-rules/${salaryRuleId}/rulesets/${rulesetId}/rules/${ruleId}`);
  }

  public getSalaryRuleRulesetRule(salaryRuleId: number, rulesetId: number, ruleId: number): Observable<any> {
    return this.httpClient.get(`/api/salary-rules/${salaryRuleId}/rulesets/${rulesetId}/rules/${ruleId}`);
  }

  public deleteSalaryRuleRulesetRuleDate(salaryRuleId: number, rulesetId: number, ruleId: number, dateId: number): Observable<any> {
    return this.httpClient.delete(`/api/salary-rules/${salaryRuleId}/rulesets/${rulesetId}/rules/${ruleId}/dates/${dateId}`);
  }

  public deleteSalaryRuleRulesetRuleExcludedDate(salaryRuleId: number, rulesetId: number, ruleId: number, dateId: number): Observable<any> {
    return this.httpClient.delete(`/api/salary-rules/${salaryRuleId}/rulesets/${rulesetId}/rules/${ruleId}/excluded-dates/${dateId}`);
  }

  public getSalaryRuleRulesetRules(salaryRuleId: number, rulesetId: number): Observable<any> {
    return this.httpClient.get(`/api/salary-rules/${salaryRuleId}/rulesets/${rulesetId}/rules`);
  }

  public saveSalaryRuleRulesetRule(salaryRuleId: number, rulesetId: number, ruleId: number, data: {}): Observable<any> {
    return this.httpClient.post(`/api/salary-rules/${salaryRuleId}/rulesets/${rulesetId}/rules/${ruleId ? ruleId : ''}`, data);
  }

  public getSalaryRuleRulesetRuleDate(salaryRuleId: number, rulesetId: number, ruleId: number, dateId: number): Observable<any> {
    return this.httpClient.get(`/api/salary-rules/${salaryRuleId}/rulesets/${rulesetId}/rules/${ruleId}/dates/${dateId}`);
  }

  public getSalaryRuleRulesetRuleExcludedDate(salaryRuleId: number, rulesetId: number, ruleId: number, dateId: number): Observable<any> {
    return this.httpClient.get(`/api/salary-rules/${salaryRuleId}/rulesets/${rulesetId}/rules/${ruleId}/excluded-dates/${dateId}`);
  }
  
  public getSalaryRuleRulesetRuleDates(salaryRuleId: number, rulesetId: number, ruleId: number): Observable<any> {
      return this.httpClient.get(`/api/salary-rules/${salaryRuleId}/rulesets/${rulesetId}/rules/${ruleId}/dates`);
  }

  public getSalaryRuleRulesetRuleExcludedDates(salaryRuleId: number, rulesetId: number, ruleId: number): Observable<any> {
    return this.httpClient.get(`/api/salary-rules/${salaryRuleId}/rulesets/${rulesetId}/rules/${ruleId}/excluded-dates`);
  }

  public saveSalaryRuleRulesetRuleDate(salaryRuleId: number, rulesetId: number, ruleId: number, dateId: number, data: {}): Observable<any> {
    return this.httpClient.post(`/api/salary-rules/${salaryRuleId}/rulesets/${rulesetId}/rules/${ruleId}/dates/${dateId ? dateId : ''}`, data);
  }

  public saveSalaryRuleRulesetRuleExcludedDate(salaryRuleId: number, rulesetId: number, ruleId: number, dateId: number, data: {}): Observable<any> {
    return this.httpClient.post(`/api/salary-rules/${salaryRuleId}/rulesets/${rulesetId}/rules/${ruleId}/excluded-dates/${dateId ? dateId : ''}`, data);
  }

  /*
    Organization
  */
  public getOrganization(): Observable<Organization> {
    return this.httpClient.get<Organization>(`/api/media/organization`);
  }

  public saveOrganization(data: object): Observable<any> {
    return this.httpClient.post(`/api/media/organization`, data);
  }

  public updateToOtherOrganizations(): Observable<any> {
    return this.httpClient.get(`/api/organization/update-to-other-organizations`, { });
  }

  /*
    Automatic products
  */
  public automaticProduct(id: number): Observable<any> {
    return this.httpClient.get(`/api/automatic-products/${id}`);
  }

  public automaticProducts(): Observable<any> {
    return this.httpClient.get(`/api/automatic-products`);
  }

  public automaticProductDelete(id: number): Observable<any> {
    return this.httpClient.delete(`/api/automatic-products/${id}`);
  }

  public automaticProductSave(id: number, data: {}): Observable<any> {
    return this.httpClient.post(`/api/automatic-products/${id ? id : ''}`, data);
  }

  /*
    Platform fees
  */
    public platformFee(id: number): Observable<any> {
      return this.httpClient.get(`/api/platform-fees/${id}`);
    }
  
    public platformFees(): Observable<any> {
      return this.httpClient.get(`/api/platform-fees`);
    }
  
    public platformFeeDelete(id: number): Observable<any> {
      return this.httpClient.delete(`/api/platform-fees/${id}`);
    }
  
    public platformFeeSave(id: number, data: {}): Observable<any> {
      return this.httpClient.post(`/api/platform-fees/${id ? id : ''}`, data);
    }

  /*
    Value Added Taxes
  */
    public vat(id: number): Observable<any> {
      return this.httpClient.get(`/api/vats/${id}`);
    }
  
    public vats(): Observable<any> {
      return this.httpClient.get(`/api/vats`);
    }
  
    public vatDelete(id: number): Observable<any> {
      return this.httpClient.delete(`/api/vats/${id}`);
    }
  
    public vatSave(id: number, data: {}): Observable<any> {
      return this.httpClient.post(`/api/vats/${id ? id : ''}`, data);
    }

  /*
    Organization Value Added Taxes
  */
  public organizationVats(): Observable<any> {
    return this.httpClient.get(`/api/organization-vats`);
  }

  public organizationVat(id: number): Observable<any> {
    return this.httpClient.get(`/api/organization-vats/${id}`);
  }

  public organizationVatDelete(id: number): Observable<any> {
    return this.httpClient.delete(`/api/organization-vats/${id}`);
  }

  public organizationVatSave(id: number, data: {}): Observable<any> {
    return this.httpClient.post(`/api/organization-vats/${id ? id : ''}`, data);
  }

  /*
    Salary Estimators
  */
  public salaryEstimators(): Observable<any> {
    return this.httpClient.get('/api/salary-estimators');
  }

  public salaryEstimator(id: number): Observable<any> {
    return this.httpClient.get(`/api/salary-estimators/${id}`);
  }

  public salaryEstimatorDelete(id: number): Observable<any> {
    return this.httpClient.delete(`/api/salary-estimators/${id}`);
  }

  public salaryEstimatorSave(id: number, data: {}): Observable<any> {
    return this.httpClient.post(`/api/salary-estimators/${id ? id : ''}`, data);
  }

  /*
    Stuff that needs translations
  */
  public translations(): Observable<any> {
    return this.httpClient.get(`/api/translations`);
  }
}